
import Vue from "vue";
import Component from "vue-class-component";
import {BFormInput, BModal} from "bootstrap-vue";
import toasts from "@/components/Toasts";
import {Prop} from "vue-property-decorator";

@Component
export default class ForwardForConfirmationModal extends Vue {
  $refs!: { bModal: BModal, urlInput: BFormInput };
  
  @Prop({required: true})
  absoluteUrl!: string;
  
  copyUrlToClipboard(targetInput: string) {
      const el = document.getElementById(targetInput) as HTMLInputElement;
      const isDisabled = el.disabled;
      if(isDisabled){
          el.disabled = false;
      }
      el.select();
      document.execCommand('copy');
      if(isDisabled){
          el.disabled = true;
      }
      toasts.success(this.$ls.Global_Toast_Success_CopiedToClipboard);
  }

  private hideModal() {
    this.$refs.bModal.hide();
  }
}
